
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { apiUrl } from 'config';
import { addNotification } from 'reapop';
import axios from 'axios';

export const changePassword = data => async (dispatch) => {
  try {
    const requestConfig = {
      url: `${apiUrl}/kjarni/api/v2/ResetPassword`,
      method: 'POST',
      data: {
        ...data,
      },
    };

    await axios(requestConfig);
    dispatch(addNotification({
      title: <FormattedMessage id="notification.ResetPassword.Success" />,
      status: 'success',
      dismissible: true,
      dismissAfter: 5000,
    }));
  } catch (err) {
    dispatch(addNotification({
      title: <FormattedMessage id="notification.ResetPassword.Error" />,
      status: 'error',
      dismissible: true,
      dismissAfter: 5000,
    }));
  }
};

export const forgotPassword = data => async (dispatch) => {
  try {
    const requestConfig = {
      url: `${apiUrl}/kjarni/api/v2/ForgotPassword`,
      method: 'POST',
      data: {
        ...data,
      },
    };

    await axios(requestConfig);
    dispatch(addNotification({
      title: <FormattedMessage id="forgotPassword.notification" />,
      status: 'success',
      dismissible: true,
      dismissAfter: 5000,
    }));
  } catch (err) {
    console.log(err);
  }
};



// WEBPACK FOOTER //
// ./src/actions/account/resetPassword.js